import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string(),
  roles: z.array(z.string()),
});

export const loginRequestSchema = z.object({
  email: z.email(),
  password: z.string().min(1),
});
